const SearchShortcutHook = {
  mounted() {
    // Store reference to the hook for cleanup
    this.handleKeydown = (event) => {
      // Check for Ctrl+F (Windows/Linux) or Cmd+F (Mac)
      if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
        // Only intercept if we're not in text mode
        const textModeFilter = this.el.dataset.textModeFilter === 'true';
        
        if (!textModeFilter) {
          // Prevent browser's default find dialog
          event.preventDefault();
          event.stopPropagation();
          
          // Trigger the search toggle event
          this.pushEvent("toggle_search", {});
        }
      }
    };
    
    // Add event listener to document to catch global shortcuts
    document.addEventListener('keydown', this.handleKeydown, true);
  },
  
  destroyed() {
    // Clean up event listener when component is destroyed
    if (this.handleKeydown) {
      document.removeEventListener('keydown', this.handleKeydown, true);
    }
  },
  
  updated() {
    // Update the data attribute when the component updates
    // This ensures we have the latest text mode state
  }
};

export default SearchShortcutHook;
